import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { buildSrc } from "@/lib/responsiveImage";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <main id="main-content" tabIndex={-1} className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Ups! Seite nicht gefunden</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Zur Startseite
        </a>
      </div>
    </main>
  );
};

export default NotFound;
